import React, { Component } from 'react'
import { observer } from 'mobx-react'
import PropTypes from 'prop-types'
import get from 'lodash/get'
import moment from 'moment'
import { formatMonthYear, formatDate } from '@atheneum/api/dist/lib'

class Experience extends Component {
  static propTypes = {
    experiences: PropTypes.array,
    cv: PropTypes.object
  }

  renderExperienceRow = () => {
    const experiences = this.props.experiences.sort((a, b) => moment(b.startDate).diff(a.startDate))

    return experiences.map(experience => {
      return (
        <div key={experience.id} className='experience-wrapper__single'>
          <div className='date'>
            <strong>{this.renderDate(experience)}</strong>
          </div>
          <div className='content'>
            <div
              className='experience-wrapper__label'
              dangerouslySetInnerHTML={{
                __html: get(experience, 'position.name', '')
              }}
            />
            {this.renderCompany(experience)}
            <span className='experience-wrapper__label'>
              {experience.location}
            </span>
            <p dangerouslySetInnerHTML={{ __html: experience.description }} />
          </div>
        </div>
      )
    })
  }

  renderDate = experience => {
    let startDate = ''
    let endDate = ''

    if (experience.current) {
      endDate = 'Now'
    }

    if (experience.startDate) {
      startDate = formatMonthYear(experience.startDate) + ' - '
    }
    if (experience.endDate) {
      endDate = formatMonthYear(experience.endDate)
    }

    const label = startDate + endDate

    return label
  }

  renderCompany = experience => {
    let date = ''

    if (experience.startDate && experience.endDate) {
      const startDate = formatMonthYear(experience.startDate)
      const endDate = formatMonthYear(experience.endDate)

      date = '(' + startDate + ' - ' + endDate + ')'
    }

    return (
      <div
        className='experience-wrapper__label'
        dangerouslySetInnerHTML={{
          __html: `<span>${get(experience, 'company.name', '')} ${date}</span>`
        }}
      />
    )
  }

  renderCvData = () => {
    const cv = this.props.cv

    const cvSourceName = get(cv, 'cvSource.name', 'not known')
    const cvUpdatedAt = get(cv, 'updated_at')

    return (
      <>
        <p className='independent-label'>
          <span>Source: {cvSourceName}</span>
        </p>
        <p className='independent-label'>
          <span>Last Updated: {formatDate(cvUpdatedAt, 'DD MMM YYYY')}</span>
        </p>
      </>
    )
  }

  render() {
    if (this.props.experiences && this.props.experiences.length === 0) {
      return null
    }

    return (
      <div className='story'>
        <span className='label'>Experience</span>
        {this.renderExperienceRow()}
      </div>
    )
  }
}

export default observer(Experience)
